import script from "./Select.vue?vue&type=script&setup=true&lang=js"
export * from "./Select.vue?vue&type=script&setup=true&lang=js"

import "./Select.vue?vue&type=style&index=0&id=74ac7cc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ac7cc8"]])

export default __exports__